import $ from "jquery";

import CampaignSelection from "./campaign_selector/campaign_selection";
import CampaignSelectorTable from "./campaign_selector/data_table";

import ActionBar from "./action_table/action_bar";
import Toast from "shared/toast";
import Ajax from "shared/ajax";

import View from "backdraft-app/src/view";

import _ from "underscore";

const template = _.template(`
  <div data-mount="action-bar"></div>
  <div class="campaigns-selection alert" style="background-color: #d9edf7">
    <div class="row">
      <div class="col-8 campaigns-selection-message">
      </div>
      <div class="col-4 campaigns-selection-count text-right">
      </div>
    </div>
  </div>
  <div class="campaigns-table"></div>
`);

export default class CampaignSelector extends View {
  get events() {
    return {
      "click .select-all-matching": "_onSelectAllMatching"
    };
  }

  constructor(options) {
    super(options);

    this.options = options || {};
    this.tableClass = this.options.tableClass || CampaignSelectorTable;

    this.model = new CampaignSelection();
    this._createChildComponents();
  }

  _createChildComponents() {
    this._createActionBar();

    // eslint-disable-next-line new-cap
    this.child("campaignsTable", new this.tableClass({
      selectedIds: this.options.selectedIds,
      listUrl: this.options.listUrl
    }));
  }

  _createActionBar() {
    this.child("actionBar", new ActionBar({
      filters: [
        {
          type: "custom",
          render: function() {
            this.$el.html("Show");
          }
        },
        {
          type: "select",
          attr: "status",
          width: this.options.statusSelectWidth || 180,
          search: false,
          items: _.map(this.options.statuses || this.model.statuses, function(text, status) {
            return { value: status, label: text };
          })
        },
        {
          type: "text",
          attr: "name",
          attributes: {
            placeholder: "Search"
          }
        }
      ],
      model: this.model
    }));
  }

  _configureEvents() {
    // notify the table when the filter attributes have changed
    this.listenTo(this.model, "change", this._filterTable);
    this.listenTo(this.child("campaignsTable"), "change:selected", this._onSelectionsChanged);
    this.listenTo(this.child("campaignsTable"), "draw", this._onTableDraw);
  }

  _filterTable() {
    this.child("campaignsTable").campaignFilter(this.model.get("status"), this.model.get("name"));
  }

  // update selections display when selections changes
  _onSelectionsChanged(info) {
    this.$selectionCount.html("<b>CAMPAIGNS SELECTED<b>: " + info.count);
    // user has selected all visible rows, ask if the want to select all matching rows now
    if (info.selectAllVisible) {
      this._showSelectAllMatching(info.count);
    } else {
      this._hideSelectAllMatching();
    }
  }

  render() {
    this.$el.html(template());
    this.$("[data-mount=action-bar]").html(this.child("actionBar").render().$el);
    this.$(".campaigns-table").html(this.child("campaignsTable").render().$el);
    this.$selectionMessage = this.$(".campaigns-selection-message");
    this.$selectionCount = this.$(".campaigns-selection-count");
    this._configureEvents();
    // apply initial filters to the table
    this._filterTable();
    this.child("campaignsTable").collection.fetch({ reset: true, error: this._defaultErrorFn });
    return this;
  }

  _defaultErrorFn(model, response, options) {
    const parsedResponse = Ajax.parseResponse(response);
    Toast.showError(parsedResponse.message);
  }

  selectedCampaignIds() {
    return _.pluck(this.child("campaignsTable").selectedModels(), "id");
  }

  _hideSelectAllMatching() {
    this.$selectionMessage.empty();
  }

  _showSelectAllMatching(count) {
    var matchingCount = this.child("campaignsTable").matchingCount();
    this._hideSelectAllMatching();

    if (count !== matchingCount) {
      // don't show this message if everything possible is already selected
      this.$selectionMessage.html(count + " campaigns selected, do you wish to select all " + matchingCount + " matching campaigns?");
      this.$selectionMessage.append(" <a href='#' data-action='yes' class='select-all-matching'>Yes</a> or <a href='#' data-action='no' class='select-all-matching'>No</a>");
    }
  }

  _onSelectAllMatching(event) {
    if ($(event.currentTarget).data("action") === "yes") {
      this.child("campaignsTable").selectAllMatching();
    }
    this._hideSelectAllMatching();
    return false;
  }

  // some aspect about the table changed, like paging, pagination size, filtering, sorting
  // clear the message to select all matching rows as it is now stale
  _onTableDraw() {
    this._hideSelectAllMatching();
  }
}
